/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

$(document).ready(function () {

  document.addEventListener("DOMContentLoaded", function () {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes("iphone")) {
      document.body.classList.add("iphone-style");
    } else if (userAgent.includes("android")) {
      document.body.classList.add("android-style");
    }
  });
          
  // Get the current URL
  var currentUrl = window.location.href;

  // Check if the URL is already the Arabic version
  if (currentUrl.includes("/ar")) {
    // Do nothing; we're already on the Arabic page
    $('.disclosure__link[data-value="ar"]').addClass(
      "disclosure__link--active"
    );
  } else {
    // Get the browser's language
    var userLang = navigator.language || navigator.userLanguage;
    var defaultLang = userLang.startsWith("ar") ? "ar" : "en";

    // Base URL with query parameters
    var baseUrl = "https://www.aiza.co/?_ab=0&_fd=0&_sc=1";

    // Redirect based on the default language
    if (defaultLang === "ar") {
      if (currentUrl.includes('?redirection=false')){
        
      }else{
        window.location.href = baseUrl.replace("www.aiza.co", "www.aiza.co/ar");
      }
    } else {
      // Set active link to English if in English mode
      $('.disclosure__link[data-value="en"]').addClass(
        "disclosure__link--active"
      );
    }
  }

  $(".disclosure__link").on("click", function (e) {
    e.preventDefault(); // Prevent default anchor click behavior

    // Base URL with query parameters
    var baseUrl = window.location.href;

    // Get the language value
    var lang = $(this).data("value");

    // Construct the new URL with query parameters
    if(baseUrl.indexOf('/ar') == -1){
      var replace_with = '/ar' + window.location.pathname;
    }else{
      var replace_with = window.location.pathname === '/' ? '' : window.location.pathname ;
    }
    
    var newUrl =
      lang === "ar"
        ? window.location.pathname === '/' ? window.location.origin + '/ar' + '?redirection=false' : (window.location.href).indexOf('/en') == -1 ? window.location.origin + '/ar' + window.location.pathname + '?redirection=false' :(window.location.href).replace("/en-sa", "/ar-sa").replace("/en-us", "/ar-us") + '?redirection=false'
        : window.location.origin+ (window.location.pathname).replace("/ar-sa", "/en-sa").replace("/ar-us", "/en-us").replace("/ar", "") + '?redirection=false'

    // Redirect to the new URL
    window.location.href = newUrl;

    // Remove active class from all links
    $(".disclosure__link").removeClass("disclosure__link--active");

    // Add active class to the clicked link
    $(this).addClass("disclosure__link--active");
  });
});

// $('body').on("click", ":not(#nav-drawer)", function (e) {
//   console.log("Click detected on an element outside #nav-drawer.");
// });
$('body').on("click", function (e) {
  if (!$(e.target).closest('div.shopify-section-header').length) {
    $('#nav-drawer').hide();
    $('body').removeClass("overflow-y-hidden");
  }
});
if($( window ).width() < 767){
  setTimeout(function() {
    var county_selectore = $('form.localization-form');
    $(".Mobile-menu-content-container-section").append(county_selectore);
  }, 500);
}else{
  setTimeout(function() {
    var county_selectore = $('form.localization-form');
    $("#NavStandard #HeaderLanguageList").append(county_selectore);
  }, 500);
}

$(document).on("click",".ingredients-new-page .image-with-text__text p strong",function() {
    var active_or_not = $(this).parents("p").hasClass("active");
  $(".ingredients-new-page .image-with-text__text p").removeClass("active");
  if(!active_or_not){
    $(this).parents("p").addClass("active");
  }
});

// if($( window ).width() < 767){
//   setTimeout(function() {
//     var app_county_selectore = $('.bacurr-cur-blocker');
//     $(".Mobile-menu-content-container-section").append(app_county_selectore);
//   }, 1000);
// }else{
//   setTimeout(function() {
//     var app_county_selectore = $('.bacurr-cur-blocker');
//     $("#NavStandard #HeaderLanguageList").append(app_county_selectore);
//   }, 1000);
// }
if($('body.template-product').length){
  $(window).scroll(function (event) {
    var scroll = $(window).scrollTop() + $(window).height();
    var footer_pos = $("#SiteFooter").position().top ;
    if(scroll >= footer_pos){
      $('.custom_submit_btn.product__submit__item').addClass('hide');
    }else{
      $('.custom_submit_btn.product__submit__item').removeClass('hide');
    }
  });
}




var user_cart = null;
if (window.location.pathname != "/cart") {
  jQuery.getJSON("/cart.js", function (cart) {
    user_cart = cart;
    cartGiftUpdate();
  });
}

$(document).ready(function () {

$(document).on("click","button.product__submit__add, button.product-upsell__btn",function(e) {
    // $('button.product__submit__add').on('submit', function (e) {
        console.log("custom_add to cart");
        e.preventDefault();
        var product_id = $(this).parents('form').find('input[name="id"]').val();
        var product_qty = $(this).parents('form').find('input[name="quantity"]').length ? parseInt($(this).parents('form').find('input[name="quantity"]').val()) : 1;
        var product_price = $(this).parents('form').find('input[name="price"]').val();
        
      cartGiftUpdate(product_id, product_price, product_qty, "ADD_TO_CART");
    });
    $(document).on("click","a.dev_cart_icon_click,a.mobile-menu__button.cart__toggle",function(e) {
      e.preventDefault();
      $('#cart-drawer').addClass('is-open');
      $('body').addClass('js-drawer-open-cart');
    });
    $(document).on("click","a.cart-drawer__close",function(e) {
      e.preventDefault();
      $('#cart-drawer').removeClass('is-open');
      $('body').removeClass('js-drawer-open-cart');
    });


//     $(document).on("click","a.cart-remove-button",function(e) {
//       e.preventDefault();
//       var product_id = $(this).parents('.CartDrawer-Item').attr('data-variant-id');
//       var product_qty = $(this).parents('.CartDrawer-Item').attr('data-quantity');
//       var product_price = $(this).parents('.CartDrawer-Item').attr('data-price');
//       cartGiftUpdate(product_id, product_price, product_qty, "REMOVED_FROM_CART");
//     });
    $(document).on("click","#cart-drawer .cart__item__quantity button",function(e) {
      e.preventDefault();
      var product_id = $(this).parents('.cart__item').attr('data-variant-id');
      var product_price = $(this).parents('.cart__item').attr('data-price');
      var button_type = $(this).attr('name');
      if(button_type == 'plus'){
        cartGiftUpdate(product_id, product_price, 1, "ADD_TO_CART");
      }else{
        cartGiftUpdate(product_id, product_price, 1, "REMOVED_FROM_CART");
      }
      
    });
});

function getCurrentTime (message) {
  var message = message ? message : '';
  let now = new Date();
  let formattedTime = now.getHours() + ":" + now.getMinutes() + ":" + now.getSeconds() + ":" + now.getMilliseconds();
  console.log(message, formattedTime);
}

function cartGiftUpdate(variantId, price, quantity, event) {
  getCurrentTime ('start time');
  console.log("cartGiftUpdate",variantId, price, quantity, event);
  const cart = user_cart; 
  const filteredObjects = JSON.parse($("body").attr("metaobject")); // Metaobject rules
  console.log("metaobject >>>", filteredObjects)
  let cartProductUpdated = {};
  let totalFreeProdCount = 0;

  var cartTotalPrice = cart.items_subtotal_price;

  let cartConfetti = '';

  // Update cart product quantities and identify freebies and remove freebies
  var free_gift_quantity =  1;
  $.each(cart.items, function (index, value) {
    const productId = value.id.toString();
    const productQuantity = value.quantity;

    cartProductUpdated[productId] = cartProductUpdated[productId]
      ? cartProductUpdated[productId]
      : productQuantity;
    
    var flag = true;
    if (productId == '49817536430377') {
      totalFreeProdCount++;
        cartProductUpdated[productId] = 0; // Exclude freebies from the product count
        cartTotalPrice = cartTotalPrice - value.final_line_price;
    }
  });

  console.log(cartTotalPrice,"cartTotalPrice 1111111")

  const cartTotalWithoutFreebie = cart.item_count - totalFreeProdCount;

  // Find the most applicable rule from the metaobject


  let adjustedCartTotal =
  cartTotalWithoutFreebie +
  (event === "ADD_TO_CART" ? 1 :
    event === "REMOVED_FROM_CART" ? -Number(quantity):
    event === "ADD_ALL_TO_CART" ? variantId.length : 0); // Adjust based on the number of items in the cart

let adjustedCartTotalPrice =
  Number(cartTotalPrice) +
  (event === "ADD_TO_CART"
    ? Number(price)
    : event === "REMOVED_FROM_CART"
    ? -(Number(quantity) * Number(price))
    : event === "ADD_ALL_TO_CART"
    ? Number(price) // Sum of all item prices in the cart
    : 0);

  console.log(adjustedCartTotalPrice,"aaa cartTotalPrice 1111111")

    if (filteredObjects.length > 0) {
      const applicableRule = filteredObjects
        .filter((rule) => {
          if(window.activeMarket == "KSA"){
            var rule_trigger_price = rule.trigger_price_sar;
          }else if(window.activeMarket == "UAE"){
            var rule_trigger_price = rule.trigger_price_uae;
          }else{
            var rule_trigger_price = rule.trigger_price_int;
          }

console.log('rule_trigger_price',rule_trigger_price);
          if (rule.triggered_quantity !== undefined) {
            return adjustedCartTotal >= rule.triggered_quantity;
          }
          if (rule_trigger_price !== undefined) {
            return adjustedCartTotalPrice >= rule_trigger_price * 100;
          }
          return false;
        })
        .sort((a, b) => {
          if(window.activeMarket == "KSA"){
            var a_trigger_price = a.trigger_price_sar;
            var b_trigger_price = b.trigger_price_sar;
          }else if(window.activeMarket == "UAE"){
            var a_trigger_price = a.trigger_price_uae;
            var b_trigger_price = b.trigger_price_sar;
          }else{
            var a_trigger_price = a.trigger_price_int;
            var b_trigger_price = b.trigger_price_sar;
          }
          // Sort based on the available field (`triggered_quantity` or `price`)
          if (a.triggered_quantity !== undefined && b.triggered_quantity !== undefined) {
            return b.triggered_quantity - a.triggered_quantity; // Higher triggered_quantity first
          }
          if (a_trigger_price !== undefined && b_trigger_price !== undefined) {
            return b_trigger_price - a_trigger_price; // Higher price first
          }
          return 0; // Default if incomparable
        })[0]; // Get the rule with the highest value

      if (applicableRule) {
        if (applicableRule.get_y?.length > 0) {
          const extractedIds = applicableRule.get_y.map((variant) =>
            variant.split("/").pop()
          );

          $.each(extractedIds, function (index, value) {
            cartProductUpdated[value] = 1
          });
        }
        if(applicableRule?.cart_confetti && event && event != 'REMOVED_FROM_CART' && applicableRule?.triggered_quantity === adjustedCartTotal ){
          cartConfetti = applicableRule.cart_confetti
        }
      }
    }

  
  //Update Cart based on addition or subtraction
  if (event) {
  if (event === "ADD_ALL_TO_CART") {
    // Handle the case where variantId is an array for "ADD_ALL_TO_CART"
    variantId.forEach((id) => {
      const productKey = id.toString();
      const currentQuantity = cartProductUpdated[productKey] || 0;
      cartProductUpdated[productKey] = currentQuantity + 1;
    });
  } else {
    // Handle individual variantId for "ADD_TO_CART" and "REMOVED_FROM_CART"
    const productKey = variantId.toString();
    const currentQuantity = cartProductUpdated[productKey] || 0;
    cartProductUpdated[productKey] =
      event === "ADD_TO_CART"
        ? currentQuantity + quantity
        : ((currentQuantity - quantity) >= 0 ? currentQuantity - quantity : 0);
  }
  }

  const final_jsonObject = {};

  final_jsonObject["updates"] = cartProductUpdated;

  const section_div_id = $('.shopify-section.shopify-section-header').attr('id');
  const sectionId = section_div_id.replace("shopify-section-", "");
  // const sectionDiv = document.querySelector(".shopify-section.shopify-section-header");
  // const sectionId = sectionDiv.id.replace("shopify-section-", ""); // Extract section ID
  console.log("Section ID:", sectionId);


  getCurrentTime("update call start time");

  //API Call for /update.js
  if (Object.keys(cartProductUpdated).length !== 0) {
    $.ajax({
      type: "post",
      url: "/cart/update.js",
      data: final_jsonObject,
      dataType: "json",
      success: function (data) {},
      complete: function (data) {
        let cartData = data.responseJSON.items
        let cart_count = data.responseJSON.item_count;
        user_cart = data.responseJSON;

        getCurrentTime("Cart data call start time");
        fetch(window.location.pathname + "?sections=" + sectionId)
        .then(res => res.json())
        .then(data => {
          console.log(data,"data sectionId", cart_count)
          const updated_cart = data[sectionId];

          if($(updated_cart).find('#cart-drawer template').length > 0){
            $('#cart-drawer').html($(updated_cart).find('#cart-drawer template').html());
          }else{
            $('#cart-drawer').html($(updated_cart).find('#cart-drawer').html());
          }

          if (event) {
            $('#cart-drawer').addClass('is-open');
            $('body').addClass('js-drawer-open-cart');
            getCurrentTime("All Complete time");
          }
        })

        // if(cart_count){
        //   $('a.cart-drawer-button').find('cart-count.count').html(cart_count);
        //   $('a.cart-drawer-button').find('cart-count.count').removeAttr('hidden');
        // }else{
        //   $('a.cart-drawer-button').find('cart-count.count').html(cart_count);
        //   $('a.cart-drawer-button').find('cart-count.count').attr('hidden',true);
        // }

      },
      error: function (error) {
        console.error("Error updating the cart:", error);
        $('button[type="submit"]').removeAttr('aria-busy');
      },
    });
  } else {

  }
}